import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { CASES_CHECKLIST_FIELDS } from "../../fragments";
const CHECKLIST_CASES = gql`
  ${CASES_CHECKLIST_FIELDS}
  query casesGetCheckList($id: Long!) {
    cases_get_checklist(id: $id) {
      ...CasesChecklistFields
    }
  }
`;
export const useQueryChecklistCases = options => {
  return useQuery(CHECKLIST_CASES, options !== null && options !== void 0 ? options : {
    errorPolicy: 'ignore'
  });
};
export const useLazyQueryChecklistCases = options => {
  return useLazyQuery(CHECKLIST_CASES, options !== null && options !== void 0 ? options : {
    errorPolicy: 'ignore'
  });
};